import _find from 'lodash/find';
import _order_by from 'lodash/orderBy';
import axios from 'axios';
import Vue from 'vue';
import { request_mutations, request_state } from '../utils/store';
import { SAVED_SEARCH_LIST, SAVED_SEARCH_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        update: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('list', 'list'),
        ...request_mutations('create', 'create'),
        ...request_mutations('update', 'update'),
        ...request_mutations('remove', 'remove'),
        rename(state, { id, name }) {
            const saved_search = _find(state.list.data.results, { id });
            Vue.set(saved_search, 'name', name);
        },
        bookmark(state, { id }) {
            const saved_search = _find(state.list.data.results, { id });
            Vue.set(saved_search, 'is_bookmarked', !saved_search.is_bookmarked);
            const ordered = _order_by(state.list.data.results, ['is_bookmarked', 'id'], ['desc', 'desc']);
            Vue.set(state.list.data, 'results', ordered);
        },
    },
    actions: {
        list({ commit }, { space_id }) {
            const url = SAVED_SEARCH_LIST.replace('{space_id}', space_id);
            axios.get(url, auth())
                .then(response => commit('list_success', response.data))
                .catch(error => commit('list_error', error.response ? error.response.data : {}));
        },
        create({ commit }, { space_id, data }) {
            const url = SAVED_SEARCH_LIST.replace('{space_id}', space_id);
            commit('create_loading');
            return new Promise((resolve) => {
                axios.post(url, data, auth()).then((response) => {
                    commit('create_success', response.data);
                    resolve();
                }).catch(error => commit('create_error', error.response ? error.response.data : {}));
            });
        },
        update({ commit }, {
            space_id, saved_search_id, patch, data,
        }) {
            const url = SAVED_SEARCH_DETAIL
                .replace('{space_id}', space_id)
                .replace('{saved_search_id}', saved_search_id);

            commit('update_loading');
            return new Promise((resolve) => {
                axios[patch ? 'patch' : 'put'](url, data, auth()).then((response) => {
                    commit('update_success', response.data);
                    resolve();
                }).catch(error => commit('update_error', error.response ? error.response.data : {}));
            });
        },
        remove({ commit }, { space_id, saved_search_id }) {
            const url = SAVED_SEARCH_DETAIL
                .replace('{space_id}', space_id)
                .replace('{saved_search_id}', saved_search_id);

            commit('remove_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_success', response.data);
                    resolve();
                }).catch(error => commit('remove_error', error.response ? error.response.data : {}));
            });
        },
    },
};
